
import React from 'react';
import { LucideIcon } from 'lucide-react';

interface WhyChooseCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  delay?: number;
}

const WhyChooseCard: React.FC<WhyChooseCardProps> = ({ 
  title, 
  description, 
  icon: Icon,
  delay = 0 
}) => {
  return (
    <div 
      className="group relative h-full"
      style={{ animationDelay: `${delay}ms` }}
    >
      {/* Professional Glassmorphism Card */}
      <div className="relative bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl md:rounded-3xl p-6 md:p-8 h-full transition-all duration-300 hover:scale-[1.02] hover:bg-white/15 hover:border-white/30 hover:shadow-soft">
        {/* Subtle Background Gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent rounded-2xl md:rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        
        {/* Professional Icon */}
        <div className="relative z-10 flex justify-center mb-6 md:mb-8">
          <div className="relative">
            {/* Gentle Glow Ring */}
            <div className="absolute inset-0 bg-secondary-brand/20 rounded-xl opacity-0 group-hover:opacity-75 transition-opacity duration-300"></div>
            
            {/* Icon Container with Professional Gradient */}
            <div className="relative w-14 h-14 md:w-16 md:h-16 bg-gradient-secondary rounded-xl flex items-center justify-center shadow-elegant group-hover:scale-110 transition-all duration-300">
              <Icon className="h-7 w-7 md:h-8 md:w-8 text-white" />
            </div>
          </div>
        </div>
        
        {/* Content */}
        <div className="relative z-10 text-center space-y-4 md:space-y-6">
          <h3 className="text-lg md:text-xl font-bold text-white group-hover:text-secondary-brand transition-colors duration-300 leading-tight">
            {title}
          </h3>
          <p className="text-sm md:text-base text-gray-300 leading-relaxed group-hover:text-white transition-colors duration-300">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseCard;
